/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const termsAndConditionsService = async () => {
  return api('/api/v2/pages/?type=terms_and_conditions.TermsAndConditionsPage&fields=paragraphs(title,text)', {}, 'GET');
};


export {
  termsAndConditionsService,
};
